import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss';

var Promotion = function Promotion(_ref) {
  var children = _ref.children;
  return React.createElement(
    'div',
    { className: styles.promotion, 'data-hook': 'menu-promotion' },
    children
  );
};

Promotion.propTypes = {
  children: PropTypes.node
};

export default Promotion;
//# sourceMappingURL=Promotion.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/SideMenu/core/Promotion.js